/**
 * Hook personalizado para funcionalidades de WhatsApp
 */

import { useCallback } from 'react';
import { COMPANY_INFO, WHATSAPP_MESSAGES } from '../constants';

/**
 * Hook para manejar interacciones con WhatsApp
 * @returns {Object} - Funciones para abrir WhatsApp con diferentes mensajes
 */
export const useWhatsApp = () => {
  const whatsappNumber = COMPANY_INFO.whatsapp;

  /**
   * Abre WhatsApp con un mensaje personalizado
   * @param {string} message - Mensaje a enviar
   */
  const openWhatsApp = useCallback((message = '') => {
    const encodedMessage = encodeURIComponent(message);
    const url = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  }, [whatsappNumber]);

  /**
   * Abre WhatsApp para cotización
   */
  const openQuote = useCallback(() => {
    openWhatsApp(WHATSAPP_MESSAGES.quote);
  }, [openWhatsApp]);

  /**
   * Abre WhatsApp para contacto general
   */
  const openContact = useCallback(() => {
    openWhatsApp(WHATSAPP_MESSAGES.contact);
  }, [openWhatsApp]);

  /**
   * Abre WhatsApp para solicitar información
   */
  const openInfo = useCallback(() => {
    openWhatsApp(WHATSAPP_MESSAGES.info);
  }, [openWhatsApp]);

  /**
   * Abre WhatsApp para cotización detallada
   */
  const openDetailedQuote = useCallback(() => {
    openWhatsApp(WHATSAPP_MESSAGES.quoteDetailed);
  }, [openWhatsApp]);

  /**
   * Abre WhatsApp para consultar sobre un servicio específico
   * @param {string} serviceName - Nombre del servicio
   */
  const openServiceInquiry = useCallback((serviceName) => {
    openWhatsApp(WHATSAPP_MESSAGES.serviceInquiry(serviceName));
  }, [openWhatsApp]);

  /**
   * Abre WhatsApp para consultar sobre contratación por horas
   * @param {string} hours - Horas de contratación
   */
  const openHiringInquiry = useCallback((hours) => {
    openWhatsApp(WHATSAPP_MESSAGES.hiringInquiry(hours));
  }, [openWhatsApp]);

  return {
    openWhatsApp,
    openQuote,
    openContact,
    openInfo,
    openDetailedQuote,
    openServiceInquiry,
    openHiringInquiry,
    whatsappNumber
  };
};

export default useWhatsApp;
